export default "__VITE_ASSET__D4qE_O1u__"